module.exports = __webpack_public_path__ + "static/media/NanumGothic.7e3295b3.ttf";